import { useMutation, useQueryClient } from "@tanstack/react-query";
import { callApi } from "../utils/ApiCallPostOnly";

export const useFinaliseOrderSave = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data) =>
      callApi({
        path: "draftorderfinalise",
        command: "save",
        data: JSON.stringify(data),
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["orderListState"] });
    },
  });
};

// const test = {
//   data: {
//     filter: { noFilter: "DF63917" },
//     header: {
//       no: "DF63917",
//       poNo: "AAA/7777",
//       requestedShippingDate: "1924-07-16",
//       shippingAgentCode: "DX-LIVE",
//       shippingChargeCode: "NS",
//       outOfSLA: true,
//       seq: 1,
//     },
//     lines: [
//       {
//         documentNo: "DF63917",
//         lineNo: "90000",
//         staffLineNo: "20000",
//         itemNo: "JKCCASSICHARCO36S",
//         quantity: "1",
//       },
//       {
//         documentNo: "DF63917",
//         lineNo: "120000",
//         staffLineNo: "10000",
//         itemNo: "PLSFR74YELNAVM",
//         quantity: "1",
//       },
//       {
//         documentNo: "DF63917",
//         lineNo: "180000",
//         staffLineNo: "10000",
//         itemNo: "FLKSTASBLACKXS",
//         quantity: "1",
//       },
//     ],
//   },
// };
